// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__lbC1D","spin":"Spinner_spin__rcHsC"};